import React from "react";
import { Layout, Typography, Grid, theme } from "antd";
import { CameraOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  background-color: white;
  
  @media (max-width: 576px) {
    padding: 12px;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: #4169e1;
  margin-bottom: 16px;
`;

const MainContent = styled(Layout.Content)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 64px);
  background-color: #f0f5ff;
  padding: 24px;
  
  @media (max-width: 576px) {
    padding: 16px;
  }
`;

const FormContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  
  @media (max-width: 576px) {
    padding: 16px;
  }
`;

interface IAuthLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

const AuthLayout: React.FunctionComponent<IAuthLayoutProps> = ({ 
  title, 
  subtitle, 
  children 
}) => {
  const { token } = useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  
  return (
    <Layout>
      <HeaderWrapper>
        <div onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <Logo>
            <span style={{ color: '#4169e1', marginRight: '8px' }}>
              <CameraOutlined />
            </span>
            RecogniX
          </Logo>
        </div>
      </HeaderWrapper>
      
      <MainContent>
        <FormContainer>
          <div style={{ 
            marginBottom: token.marginXL, 
            textAlign: "center" 
          }}>
            <Title 
              style={{ 
                fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
                marginBottom: subtitle ? token.marginSM : 0 
              }}
            >
              {title}
            </Title>
            
            {subtitle && (
              <Text style={{ color: token.colorTextSecondary }}>
                {subtitle}
              </Text>
            )}
          </div>
          
          {children}
        </FormContainer>
      </MainContent>
    </Layout>
  );
};

export default AuthLayout;